import type { CouponId } from '../../../../schema/coupon/entry.js';
import type { IGetCouponWalletsUseCase } from '../../../domain/entry.js';

export type IGetCouponWalletsController = ReturnType<typeof getCouponWalletsController>;

type ControllerArgs = { couponId: CouponId };

/**
 * Controller for getting coupon wallet.
 *
 * @param getCouponWalletsUseCase Use case for getting a coupon's wallets
 * @returns Controller executor function
 */
export function getCouponWalletsController(getCouponWalletsUseCase: IGetCouponWalletsUseCase) {
  return function controller({ couponId }: ControllerArgs): ReturnType<IGetCouponWalletsUseCase['execute']> {
    return getCouponWalletsUseCase.execute({ couponId });
  };
}
